// extracted by mini-css-extract-plugin
export default {"tooltip":"A8-z","arrow":"B8-z"};